module.exports = __webpack_public_path__ + "static/img/noUp.d4077715.png";